import { Button as MuiButton } from '@mui/material'

const Button = ({ children, variant = 'contained', color = 'primary', onClick, ...props }) => {
  return (
    <MuiButton variant={variant} color={color} onClick={onClick} {...props}>
      {children}
    </MuiButton>
  )
}

export default Button
